import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import common from './common'
import auth from './auth'
import client from './client'
import artist from './artist'
import statistics from './statistics'
import projects from './projects'
import agency from './agency'
import company from './company'
import info from './company'


const reducers = combineReducers({
	auth,
	common,
  client,
  artist,
  agency,
  statistics,
  projects,
  company,
  router: routerReducer,
	form: formReducer
});

export default reducers;


// WEBPACK FOOTER //
// ./src/reducers/index.js